<script>
import Draggable from 'vuedraggable';
import { VBTooltip } from 'bootstrap-vue';
import BuilderIcon from './BuilderIcon';
import BuilderProp from './BuilderProp';
import BuilderSettings from './BuilderSettings';
import BuilderIntegration from './BuilderIntegration';
import { Confirm } from '../../services/Confirm';
import { Alert } from '../../services/alert';

const politics = [
  {
    options: [
      {
        points: '',
        value: 'Eu concordo em receber comunicações',
        option: 'Eu concordo em receber comunicações',
      },
    ],
    type: 'checkbox',
    title: 'Política de Privacidade',
    name: 'consent-term',
    question: 'Política de Privacidade',
  },
];

export default {
  components: {
    Draggable,
    BuilderProp,
    BuilderIcon,
    BuilderSettings,
    BuilderIntegration,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  created () {
    window.onbeforeunload = () => {
      if (! _.isEqual(this.backupForm, this.localForm) || this.key > 1) {
        return this.__('Seu conteúdo não está salvo. Deseja realmente sair do editor?');
      }
    };

    this.localForm = { ...this.localForm, ...this.form };

    this.backupForm = this.form;

    if (this.dataFields) {
      this.fields = this.handleFields(this.dataFields);

      this.getForm();

      return;
    }

    Bus.$on('fieldsRetrieved', (fields) => {
      this.fields = this.handleFields(fields);

      this.getForm();
    });
  },

  props: {
    form: {
      type: Object,
      required: false,
      default: null,
    },

    dataFields: {
      type: Array,
      required: false,
      default: null,
    },

    hideIntegration: {
      type: [
        Boolean, String
      ],
      required: false,
      default: false,
    },

    page: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data: () => ({
    key: 0,
    search: '',
    loading: true,
    saving: false,
    isDisabled: false,
    currentEdit: null,
    showSettings: true,
    showIntegration: false,
    showModalCustom: false,
    integrationLoading: false,
    backupForm: null,
    localForm: {
      name: '',
      action: '',
      button: '',
      description: '',
      action_content: '',
      hide_labels: false,
    },
    fields: [
      //
    ],
    questions: [
      //
    ],
  }),

  computed: {
    textDone () {
      return this.isDisabled ? this.__('Salvando...') : this.__('Salvar');
    },

    politics () {
      return politics.filter((field) => this.questions.findIndex(({ name }) => name === field.name) === -1
          && field.question.toLowerCase().includes(this.search.toLowerCase()));
    },

    _fields () {
      return this.fields.filter((field) => this.questions.findIndex(({ name }) => name === field.name) === -1
          && field.question.toLowerCase().includes(this.search.toLowerCase()));
    },
  },

  methods: {
    getForm () {
      this.$http.get(`/form/${this.form.id}/question`)
        .then(({ data }) => {
          this.questions = _.sortBy(data, 'order');
          this.handleFilterFields(this.fields);
          this.loading = false;
        });
    },

    getTypeName (question) {
      const name = _.find(question.type, (type) => question.type == type.value);

      return name || question.type;
    },

    handleField (field) {
      if (field.options) {
        field.options = field.options.map((item) => ({
          ...item, option: item.value,
        }));
      }

      const type = ['email', 'e-mail'].includes(field.identifier)
        ? 'email'
        : field.field_type;

      return {
        type,
        name: field.identifier,
        options: field.options,
        title: field.description,
        question: field.description,
      };
    },

    handleFields (fields) {
      return fields.map((item) => this.handleField(item));
    },

    handleCustomField ({ stored }) {
      if (! stored) {
        this.showModalCustom = false;

        return;
      }

      const field = this.handleField(stored);

      this.fields.push(
        field,
      );

      this.handleCreate(field, this.fields.length - 1, false);

      this.showModalCustom = false;
    },

    handleCreate (modal, index, flag = true) {
      this.saving = true;

      this.$http.post(`/form/${this.form.id}/question`, { ...modal, pageId: this.page })
        .then(({ data }) => {
          this.handleShow(data);

          if (flag) {
            const modalIndex = this.questions.findIndex(({ question }) => question === modal.question);

            this.questions[modalIndex] = data;

            return;
          }

          this.questions.push(data);

          this.$delete(this.fields, index);

          this.key += 1;
        })
        .catch((response) => {
          if (response.status === 422) {
            Alert.error(this.__('Preencha o título do campo.'));
          }

          Alert.error(this.__('Erro ao cadastrar campo'));
        })
        .finally(() => {
          this.saving = false;
        });
    },

    handleFilterFields (fields) {
      this.fields = fields.filter((field) => this.questions.findIndex(({ name }) => name === field.name) === -1);
    },

    handleEdit (payload) {
      const index = this.questions.findIndex(({ id }) => id === payload.id);

      this.questions[index] = { ...this.questions[index], ...payload };

      this.key += 1;
    },

    async handleRemove (id, index) {
      if (! await Confirm(this.__('Deseja excluir?'))) {
        return;
      }

      this.$http.delete(`/form/${this.form.id}/question/${id}`)
        .then(() => {
          const key = ['politics-consent', 'consent'].includes(this.questions[index].name)
            ? 'politics'
            : 'fields';

          /**
             * Todo: use includes if exists more categories
             */
          if (key === 'fields') {
            this[key].push(this.questions[index]);
          }

          this.$delete(this.questions, index);
        })
        .catch(({ message }) => {
          if (message) {
            Alert.error(message);
          }
        });
    },

    handleOrder () {
      const order = this.questions.map((question) => question.id);

      this.$http.put(`/form/${this.form.id}/question-order`, { orders: order })
        .catch(() => {
          Alert.error(this.__('Erro ao alterar ordem, tente novamente mais tarde.'));
        });
    },

    handleChange ({ added = null }) {
      if (! added) {
        return;
      }

      const {
        element,
        newIndex,
      } = added;

      this.handleCreate(element, newIndex);
    },

    handleShow (question) {
      this.showSettings = false;
      this.showIntegration = false;

      this.currentEdit = question;
    },

    handleSettings () {
      this.showIntegration = false;

      this.showSettings = ! this.showSettings;
    },

    handleMove ({ from: { id: fromId }, to: { id: toId } }) {
      if (fromId === 'field-list' && toId === 'options-list') {
        return false;
      }
    },

    handleSave () {
      this.integrationModal = false;

      this.currentEdit = null;

      this.isDisabled = true;

      this.saving = true;

      this.handleOrder();

      this.$nextTick(() => {
        if (! _.isEqual(this.localForm, this.form)) {
          this.$http.put(`/form/${this.form.id}`, { ...this.localForm, pageId: this.page })
            .then(() => this.backupForm = this.localForm);
        }

        if (this.questions.length === 0) {
          Alert.info(this.__('Formulário salvo'));

          this.isDisabled = false;

          this.saving = false;

          Bus.$emit('saveBeeForm');

          return;
        }

        const savePromises = this.questions.map(payload => 
          this.$http.put(`/form/${this.form.id}/question/${payload.id}`, { ...payload, pageId: this.page })
            .then(response => {
              return response.data;
            })
            .catch(() => {
              Alert.error(this.__('Erro ao cadastrar campo'));
              return null;
            })
        );

        Promise.all(savePromises)
          .then(updatedQuestions => {
            this.questions = updatedQuestions.filter(q => q !== null);
            this.key = 0;
            this.isDisabled = false;
            this.saving = false;
            Alert.info(this.__('Formulário salvo'));
            
            if (this.hideIntegration) {
              Bus.$emit('saveBeeForm', toBeeForm(this.localForm, this.questions, this.page));
            }
          });
      });
    },
  },
};
</script>

<template>
  <div
    class="form-builder"
  >
    <div
      class="form-builder__header"
    >
      <div
        class="form-builder__menu"
      >
        <button
          v-if="! hideIntegration"
          @click.prevent="showIntegration = ! showIntegration"
          class="form-builder__menu-button form-builder__menu-button--iframe"
        >
          <IconFrame
            color="#ffffff"
          />
        </button>

        <button
          class="form-builder__menu-button"
          @click.prevent="handleSettings"
        >
          <IconCog
            color="#ffffff"
          />
        </button>

        <button
          v-text="textDone"
          @click.prevent="handleSave"
          class="form-builder__menu-done"
          :class="{ 'is-disabled': isDisabled }"
        />
      </div>
    </div>

    <div
      class="form-builder__body"
    >
      <div
        class="form-builder__options"
      >
        <h5
          class="form-builder__title pb-20px sticky-top"
        >
          <span
            class="form-builder__title-text"
          >
            {{ __('Campos disponíveis') }}
          </span>

          <button
            @click.prevent="showModalCustom = true"
            :class="{ 'has-border-left': hideIntegration }"
            v-b-tooltip.bottom="__('Cadastrar novo campo')"
            class="form-builder__menu-button form-builder__menu-button--plus"
          >
            <IconPlus
              color="#857a98"
            />
          </button>
        </h5>

        <div
          class="form-builder__search"
        >
          <input
            v-model="search"
            class="form-builder__search-input"
            :placeholder="__('Digite para pesquisar um campo')"
          >

          <button
            @click.prevent="search = ''"
            class="form-builder__search-close"
          >
            <IconClose
              color="#b2a8c1"
              class="form-builder__search-close-icon"
            />
          </button>
        </div>

        <template
          v-if="politics.length > 0"
        >
          <div
            class="form-builder__category"
          >
            {{ __('Proteção de Dados') }}
          </div>

          <Draggable
            tag="ul"
            :sort="false"
            :list="politics"
            id="options-list"
            :move="handleMove"
            class="list-politics"
            :group="'questions'"
            :key="`${search}-politics-${fields.length}`"
          >
            <template
              v-for="(field, index) in politics"
            >
              <li
                :class="{ 'is-saving': saving }"
                :key="`${field.question}-${index}-${search}`"
                @click.prevent="handleCreate(field, index, false)"
                class="row list-group-item d-flex form-builder__options-option"
                v-if="field.question.toLowerCase().includes(search.toLowerCase())"
              >
                <BuilderIcon
                  type="text"
                  class="form-builder__drag-icon"
                />

                <span
                  v-text="field.question"
                  class="form-builder__options-option-text"
                />
              </li>
            </template>
          </Draggable>

          <div
            v-if="_fields.length > 0"
            class="form-builder__category"
          >
            {{ __('Campos') }}
          </div>
        </template>

        <Draggable
          tag="ul"
          :sort="false"
          :key="search"
          :list="fields"
          id="options-list"
          :move="handleMove"
          class="list-group "
          :group="'questions'"
        >
          <template
            v-for="(field, index) in fields"
          >
            <li
              :class="{ 'is-saving': saving }"
              :key="`${field.question}-${index}-${search}`"
              @click.prevent="handleCreate(field, index, false)"
              class="row list-group-item d-flex form-builder__options-option"
              v-if="field.question.toLowerCase().includes(search.toLowerCase())"
            >
              <BuilderIcon
                type="text"
                class="form-builder__drag-icon"
              />

              <span
                v-text="field.question"
                class="form-builder__options-option-text"
              />
            </li>
          </template>
        </Draggable>
      </div>

      <div
        class="form-builder__questions"
      >
        <h5
          class="form-builder__title pb-20px sticky-top"
        >
          {{ __('Campos selecionados') }}
        </h5>

        <Draggable
          tag="ul"
          :key="key"
          id="field-list"
          class="list-group"
          :list="questions"
          :move="handleMove"
          :group="'questions'"
          @change="handleChange"
          ghost-class="form-builder__drag"
        >
          <li
            :key="`${question.question}-${index}`"
            v-for="(question, index) in questions"
            @click.prevent="handleShow(question)"
            class="row list-group-item d-flex form-builder__questions-option"
            :class="{
              'is-saving': saving,
              'is-active': currentEdit && currentEdit.id === question.id,
            }"
          >
            <span
              v-if="question.step"
              class="form-builder__questions-option-text"
            >
              Passo {{ question.step }})&nbsp;
            </span>

            <BuilderIcon
              :type="question.type"
              class="form-builder__questions-option-icon"
            />

            <span
              class="form-builder__questions-option-text"
            >
              {{ question.question }}
            </span>

            <button
              class="form-builder__questions-option-button"
              @click.prevent="handleRemove(question.id, index)"
            >
              <IconTrash
                color="#3B334A"
              />
            </button>
          </li>

          <div
            class="form-builder__dropzone"
          >
            <span
              class="form-builder__dropzone-title"
            >
              {{ __('Adicione aqui os campos do formulário') }}
            </span>

            <span
              class="form-builder__dropzone-subtitle"
            >
              {{ __('Segure e arraste para selecionar um campo') }}
            </span>
          </div>
        </Draggable>
      </div>

      <div
        class="form-builder__properties"
      >
        <BuilderIntegration
          v-if="showIntegration"
          :formhashid="form.hashid"
        />

        <BuilderSettings
          :form="localForm"
          v-else-if="showSettings"
          :name.sync="localForm.name"
          class="form-builder__settings"
          :action.sync="localForm.action"
          :button.sync="localForm.button"
          :description.sync="localForm.description"
          :action_content.sync="localForm.action_content"
          :hide_labels.sync="localForm.hide_labels"
        />

        <template
          v-else
        >
          <h5
            class="form-builder__title pb-20px sticky-top"
          >
            {{ __('Propriedades') }}
          </h5>

          <BuilderProp
            :form="localForm"
            @save="handleEdit"
            v-if="currentEdit"
            :field="currentEdit"
          />

          <div
            v-else
            class="form-builder__properties-warning"
          >
            {{ __('Selecione algum campo do seu formulário para visualizar as propriedades') }}.
          </div>
        </template>
      </div>
    </div>

    <TenantCustomFieldModal
      :open="showModalCustom"
      @close="handleCustomField"
    />
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';

  .form-builder {
    width: 100%;
    height: 75vh;
    display: flex;
    flex-flow: column;
    box-shadow: $card-box-shadow;

    &__title {
      width: 100%;
      height: 40px;
      display: flex;
      flex-shrink: 0;
      font-size: .8rem;
      font-weight: 400;
      text-align: left;
      margin-top: 10px;
      line-height: 15px;
      color: #857a98;
      position: relative;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-family: $input-font-family;

      &-text {
        left: 50%;
        position: relative;
        transform: translatex(-50%);
      }
    }

    &__header {
      height: 55px;
      display: flex;
      justify-content: flex-end;
      background-color: #363b3d;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    &__category {
      width: 100%;
      padding: 4px 0px 8px 15px;
    }

    &__menu {
      display: flex;

      &-button {
        width: 60px;
        border: none;
        outline: none;
        background-color: transparent;

        &--plus {
          top: -2px;
          width: 55px;
          margin-left: auto;
          position: relative;
          border-right: solid 1px rgba($gray-white, .2);

          &.has-border-left {
            border-left: solid 1px rgba($gray-white, .2);
          }

          & > :first-child {
            transform: translateX(-4px);
          }
        }

        &--iframe {
          border-left: solid 1px rgba($gray-white, .2);
          border-right: solid 1px rgba($gray-white, .2);
        }
      }

      &-done {
        width: 80px;
        border: none;
        outline: none;
        color: $white;
        font-weight: bold;
        background-color: $green;
        border-top-right-radius: 5px;
        font-family: $font-family-sans-serif;

        &.is-disabled {
          cursor: not-allowed;
        }
      }
    }

    &__body {
      display: flex;
      height: calc(100% - 55px);
    }

    &__options {
      flex: 1;
      height: 100%;
      display: flex;
      overflow: hidden;
      max-height: 100%;
      padding: 4px 12px;
      align-items: center;
      box-sizing: border-box;
      flex-flow: column nowrap;
      background-color: #f9f9f9;
      border-bottom-left-radius: 5px;
      border-right: solid 1px $gray-white;

      .list-group {
        width: 100%;
        overflow: overlay;
        align-items: center;

        .form-builder__drag-icon {
          display: none;
        }
      }

      .list-politics {
        width: 100%;
        padding: 0px;
        display: flex;
        align-items: center;
        flex-flow: column nowrap;

        .form-builder__drag-icon {
          display: none;
        }
      }

      &-option {
        width: 90%;
        display: flex;
        flex-shrink: 0;
        cursor: pointer;
        margin: 5px 0px;
        min-height: 60px;
        border-radius: 3px;
        align-items: center;
        justify-content: center;
        background-color: $white;
        border: solid 1px $gray;

        &-text {
          font-size: 14px;
          font-weight: 400;
          font-family: $font-family-sans-serif;
        }
      }
    }

    &__search {
      width: 100%;
      display: flex;
      flex-shrink: 0;
      position: relative;
      margin: -8px 0px 10px;
      justify-content: center;

      &-input {
        width: 90%;
        height: 52px;
        border: none;
        font-size: 13px;
        color: #3b334a;
        font-weight: 400;
        line-height: 16px;
        border-radius: 5px;
        box-sizing: border-box;
        background-color: white;
        padding: .375rem 26px .375rem 1.2rem;
        font-family: $font-family-sans-serif;
      }

      &-close {
        right: 25px;
        border: none;
        outline: none;
        position: absolute;
        top: calc(50% - 1px);
        transform: translateY(-50%);
        background-color: transparent;
      }
    }

    &__questions {
      flex: 2;
      overflow: auto;
      max-height: 100%;
      padding: 4px 12px;
      box-sizing: border-box;
      background-color: $white;

      .list-group-item {
        margin: 5px 0px !important;
      }

      .list-group,
      .list-politics {
        align-items: center;
        min-height: calc(100% - 100px);
      }

      &-option {
        width: 80%;
        margin: 5px 0px;
        cursor: pointer;
        min-height: 60px;
        border-radius: 3px;
        align-items: center;
        flex-flow: row nowrap;
        justify-content: center;
        border: solid 1px $gray;
        background-color: $white;
        display: flex !important;
        box-shadow: 0 1px 1px rgb(0 0 0 / 5%);

        &-icon {
          top: -1px;
          margin-right: 8px;
          position: relative;
        }

        &.is-saving {
          pointer-events: none !important;
        }

        &.is-active {
          background: rgba(222,242,250,0.85);
          border: solid 1px #3AAEE0 !important;
        }

        &-text {
          font-size: 14px;
          font-weight: 500;
          font-family: $font-family-sans-serif;
        }

        &-button {
          top: -1px;
          border: none;
          margin-left: auto;
          position: relative;
          background-color: transparent;
        }
      }
    }

    &__dropzone {
      width: 80%;
      display: flex;
      font-size: 14px;
      margin-top: 10px;
      min-height: 100px;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      flex-flow: column nowrap;
      background-color: #f9f9f9;
      border: dashed 1px #b2a8c1;
      font-family: $font-family-sans-serif;

      &-title {
        font-weight: 500;
        color: $gray-dark;
      }

      &-subtitle {
        font-size: 12px;
        color: $gray-light;
      }
    }

    &__properties {
      flex: 1;
      overflow: auto;
      max-height: 100%;
      padding: 4px 12px;
      box-sizing: border-box;
      background-color: #f9f9f9;
      border-bottom-right-radius: 5px;
      border-left: solid 1px $gray-white;

      &-warning {
        text-align: center;
      }
    }

    &__drag {
      width: 80%;
      height: 60px;
      display: flex;
      cursor: pointer;
      margin: 5px 0px;
      border-radius: 3px;
      align-items: center;
      background-color: $white;
      border: solid 1px $gray;
      justify-content: flex-start;
      box-shadow: 0 1px 1px rgb(0 0 0 / 5%);

      &-icon {
        top: -1px;
        margin-right: 8px;
        position: relative;
        display: inline-block;
      }

      .form-builder__options-option-text {
        font-size: 14px;
        font-weight: 500;
        font-family: $font-family-sans-serif;
      }
    }
  }
</style>
